import React from 'react';
import { useAsync } from 'helpers/hooks';
import { useTranslation } from 'react-i18next';
import { ToastContext } from 'contexts';
import { useAuth } from 'providers/AuthProvider';
import { useHistory } from 'react-router';

const getConfirmationToken = () => {
  const token = window.location.hash.substr(1);
  return token.length ? token : null;
};

export default () => {
  const { t } = useTranslation();
  const { triggerToast } = React.useContext(ToastContext);
  const { confirm, logout } = useAuth();
  const history = useHistory();

  const confirmationToken = React.useMemo(getConfirmationToken, [getConfirmationToken]);

  const isTokenMissing = confirmationToken === null;

  const doConfirm = React.useCallback(() => {
    return confirm(confirmationToken);
  }, [confirmationToken, confirm]);

  const [confirmResult] = useAsync(doConfirm, !isTokenMissing);

  if (isTokenMissing) {
    history.push('/');
  }

  if (confirmResult.isError) {
    triggerToast({ message: t('login.confirm_error') });
    history.push('/');
  }

  if (confirmResult.isSuccess) {
    triggerToast({ message: t('login.confirm_success'), variant: 'success' });
    logout();
    history.push('/login');
  }

  return confirmResult;
};
